'use client';

import { createContext } from 'react';

import type { User } from '@ps/functions/firebase/auth';
import { BehaviorSubject } from 'rxjs';

export type AuthContextValue = {
  currentUserId$: BehaviorSubject<string | null | undefined>;
  /**
   * The full resolved Firebase user (not just the uid) — `undefined` while
   * auth is still resolving, then the `User` or `null`. Exposed alongside
   * `currentUserId$` so consumers that need the user itself (e.g. the bio
   * session warmer, which mints/marks the `__session` cookie from it) can
   * read it off the ONE provider subscription rather than opening their own.
   */
  currentUser$: BehaviorSubject<User | null | undefined>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);
